// Globals
import { useMemo, useState } from 'react';
import { MenuProps } from 'antd';
import { Rule } from 'antd/es/form';

// Components
import { FormItemContainer, StyledMenu, StyledWrapper } from './CategoryNameSwitchStyles';
import { Input } from '@/ui';
import { StyledFormItem } from '../Styled';

// Models
import { CategoryLocaleCodes, ICategoryNameLocale } from '@/models/categories.model';

// Helpers
import { getCategoryNameTabsConfig } from '../../helpers/configs';

type TCategoryNameSwitch = {
  label: string;
  formItemName: string;
  locale: ICategoryNameLocale[];
  validationRules?: Rule[];
};

const CategoryNameSwitch = ({ label, formItemName, locale, validationRules }: TCategoryNameSwitch) => {
  // TODO: discuss the full flow and refine this logic
  const ukLocaleIndex = useMemo(() => locale.findIndex((item) => item.locale === CategoryLocaleCodes.UK), [locale]);
  const ruLocaleIndex = useMemo(() => {
    const index = locale.findIndex((item) => item.locale === CategoryLocaleCodes.RU);
    // TODO: remove this workaround when fixed on BE
    return index !== -1 ? index : ukLocaleIndex + 1;
  }, [locale]);

  const tabsConfig = useMemo(() => getCategoryNameTabsConfig(), []);
  const [selectedTabKey, setSelectedTabKey] = useState(tabsConfig[0].key);

  const onClick: MenuProps['onClick'] = (e) => {
    setSelectedTabKey(e.key as CategoryLocaleCodes);
  };

  return (
    <StyledWrapper>
      <StyledMenu mode="horizontal" items={tabsConfig} defaultSelectedKeys={[selectedTabKey]} onClick={onClick} />

      <FormItemContainer hidden={selectedTabKey !== CategoryLocaleCodes.UK}>
        <StyledFormItem name={[formItemName, ukLocaleIndex, 'locale']} hidden>
          <Input type="hidden" />
        </StyledFormItem>
        <StyledFormItem name={[formItemName, ukLocaleIndex, 'name']} label={label} rules={validationRules}>
          <Input />
        </StyledFormItem>
      </FormItemContainer>

      <FormItemContainer hidden={selectedTabKey !== CategoryLocaleCodes.RU}>
        <StyledFormItem name={[formItemName, ruLocaleIndex, 'locale']} hidden>
          <Input type="hidden" />
        </StyledFormItem>
        <StyledFormItem name={[formItemName, ruLocaleIndex, 'name']} label={label} rules={validationRules}>
          <Input />
        </StyledFormItem>
      </FormItemContainer>
    </StyledWrapper>
  );
};

export default CategoryNameSwitch;
